import React, {useContext} from 'react'
import { Dialog, DialogProps } from '@mui/material';
import {AppAdminContext} from '../../../app/AppAdminContext'
import styled from 'styled-components'
import {isAndroid} from 'react-device-detect'

export const AdminDialogBase = (props: DialogProps) => {
    const applyAndroidFix = !useContext(AppAdminContext).showSpModePage && isAndroid
    return <>
        <StyledDialog
            {...props}
            transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
            $applyAndroidFix={applyAndroidFix}
        />
    </>
}

const StyledDialog = styled(Dialog)<{ $applyAndroidFix: boolean }>`
  ${props => props.$applyAndroidFix && `
    // Android向けDialogの位置を修正するcssを独自に指定する
    height: 100vh;
    .MuiDialog-paperScrollPaper {
      max-height: 100%;
    }
  `}
`
